import React, { useEffect, useRef, useState } from 'react'
import './challenges-landing.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import ChallengesList from './challenges-list.component';
import ChallengesForm from './challenges-form.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useSelector } from 'react-redux';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import { properCase } from '@/utils/properCase';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import { getCollectionFromDb } from '@/utils/getDataFromDb';
import { completeGameElementData } from '@/components/PREVIEW/previewGameElements';


const ChallengesLandingPage = ({ gameElements, gameData, playerList, gameStats }) => {

  const membership = useSelector(state => state.userData.membership);
  const [showUpgradeModal, setShowUpgradeModal] = useState(null);
  const [challengesFromDb, setChallengesFromDb] = useState(null);
  const [challengesRetrieved, setChallengesRetrieved] = useState(false);
  const navigate = useNavigate();
  let challengesListener;
  const challengesRef = useRef();
  const location = useLocation();

  useEffect(() => {

    return () => {
      if (challengesListener) challengesListener();
    }
  }, [])

  useEffect(() => {
    if (!membership || !gameData) return;
    checkMembership();
  }, [membership, gameData])

  useEffect(() => {
    if (!gameData || challengesRetrieved) return;
    getGameElementsToManage();
    setChallengesRetrieved(true);
  }, [gameData])

  function checkMembership() {
    const element = 'challenges'
    const res = testMemberRestrictions({ 'gameData': gameData, 'membership': membership, 'element': element })
    // console.log(res);
    if (res.disabled) {
      let message = ''
      const planRest = membershipRestrictions[membership.membership];
      if (res.disabledReason.includes(element)) {
        message = `While using the ${planRest.title}, you are not able to access ${properCase(element)}.`;
      }
      setShowUpgradeModal(message)
    }
  }

  function getGameElementsToManage() {
    if (location.pathname.includes('/preview/manager/')) {
      const challengeObj = {};
      Object.values(completeGameElementData)
        .filter(e => e.type === 'challenge' && e.status === 'active')
        .forEach(e => {
          challengeObj[e.id] = e;
        });
      setChallengesFromDb(challengeObj);
      return;
    }
    getCollectionFromDb({
      "collection": `games/${gameData.gameId}/gameElements`,
      "query1": {
        "key": "type",
        "condition": "==",
        "value": "challenge"
      },
      "callback": callback,
      "handleListener": handleListener
    })
    function callback(data) {
      challengesRef.current = {
        ...challengesRef.current,
        ...{ [data.id]: data }
      }
      setChallengesFromDb(challengesRef.current);
    }
    function handleListener(data) {
      challengesListener = data;
    }
  }

  return (
    <div className='challenges-landing'>
      <Routes>
        <Route path='' element={
          <div className='g-card challenges-card'>
            <BackButton cancel={() => navigate(-1)} />
            <div className="g-space-1"></div>
            <div className='card-title'>
              <ImageContainer src='/images/icons/challenge.png' className='head-icon' />
              Create and Edit Challenges</div>
            <hr />
            <div className='challenges-landing-content'></div>
            <ChallengesList
              gameElements={gameElements}
              challengesFromDb={challengesFromDb}
              gameData={gameData}
            />
          </div>
        }></Route>
        <Route path='create' element={
          <ChallengesForm
            gameElements={gameElements}
            challengesFromDb={challengesFromDb}
            gameData={gameData}
            playerList={playerList}
            gameStats={gameStats}
          />
        }></Route>
        <Route path='edit/:challengePath' element={
          <ChallengesForm
            gameElements={gameElements}
            challengesFromDb={challengesFromDb}
            gameData={gameData}
            playerList={playerList}
            gameStats={gameStats}
          />
        }></Route>
        <Route path="*" element={<Navigate replace to="/404" />} />
      </Routes>
      <UpgradeRequiredModal
        show={showUpgradeModal}
        cancel={() => setShowUpgradeModal(null)}
        message={showUpgradeModal}
      />
    </div>
  )
}

export default ChallengesLandingPage